// extracted by mini-css-extract-plugin
export var modal = "modal-module--modal--UVKtg";